import React, { type SVGProps } from 'react';

interface IconProps extends SVGProps<SVGElement> {
  fillColor?: string;
}
const AddIcon = ({ fillColor = 'var(--primaryText)', ...props }: IconProps) => {
  const { className } = props;

  return (
    (<svg
      width="14px"
      height="14px"
      className={className}
      aria-hidden="true"
      focusable="false"
      data-prefix="fal"
      data-icon="plus"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 384 512"
      data-palette="AddIcon">
      <path
        fill={fillColor}
        d="M376 232H216V72c0-4.42-3.58-8-8-8h-32c-4.42 0-8 3.58-8 8v160H8c-4.42 0-8 3.58-8 8v32c0 4.42 3.58 8 8 8h160v160c0 4.42 3.58 8 8 8h32c4.42 0 8-3.58 8-8V280h160c4.42 0 8-3.58 8-8v-32c0-4.42-3.58-8-8-8z"
      />
    </svg>)
  );
};

export default AddIcon;
